// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import "./src/css/global.css"